import { config } from "config";
import { Message } from "wall/types/message.model";

export class MessageService {
  private static headers() {
    return {
      Authorization: `Bearer ${JSON.parse(
        sessionStorage.getItem("quizToken")!,
      )}`,
    };
  }

  listMessages(listMessagesData: { wallId: string }): Promise<Message[]> {
    return fetch(
      `${config.apiRoot}/messages?wallId=${listMessagesData.wallId}`,
      {
        method: "GET",
        headers: MessageService.headers(),
      },
    ).then((resp) => resp.json());
  }
}
